import moment from 'moment-timezone'

export const DEFAULT_PAY_CODE_START_TIME = '07:00'

export function getWorkDayStartTime(paymentSettings) {
  return normalizePayCodeTime(paymentSettings?.work_day_start, DEFAULT_PAY_CODE_START_TIME)
}

export function normalizePayCodeTime(value, fallback = DEFAULT_PAY_CODE_START_TIME) {
  if (moment.isMoment(value)) {
    return value.format('HH:mm')
  }

  if (!value) {
    return fallback
  }

  const time = moment(String(value), ['HH:mm', 'HH:mm:ss', 'hh:mm A'], true)

  if (time.isValid()) {
    return time.format('HH:mm')
  }

  const date = moment(value)

  return date.isValid() ? date.format('HH:mm') : fallback
}

export function timePickerValue(value, fallback = DEFAULT_PAY_CODE_START_TIME) {
  return moment(normalizePayCodeTime(value, fallback), 'HH:mm')
}

export function getWorkDayWindow(date, workDayStart, timeZone) {
  const dateMoment = moment.isMoment(date) ? date.clone() : moment.utc(date)
  const [hours, minutes] = normalizePayCodeTime(workDayStart).split(':')
  const start = moment
    .tz(dateMoment.format('YYYY-MM-DD'), 'YYYY-MM-DD', timeZone)
    .hour(Number(hours))
    .minute(Number(minutes))
    .second(0)
    .millisecond(0)

  return {
    start,
    end: start.clone().add(1, 'day')
  }
}

export function getScheduledStartForWorkDay(date, time, workDayStart, timeZone) {
  const { start } = getWorkDayWindow(date, workDayStart, timeZone)
  const [hours, minutes] = normalizePayCodeTime(time).split(':')
  const scheduledStart = start.clone().hour(Number(hours)).minute(Number(minutes)).second(0).millisecond(0)

  if (scheduledStart.isBefore(start)) {
    scheduledStart.add(1, 'day')
  }

  return scheduledStart
}

export function getWorkDayDateForShift(scheduledStart, workDayStart, timeZone) {
  const start = moment.isMoment(scheduledStart)
    ? scheduledStart.clone().tz(timeZone)
    : moment.utc(scheduledStart).tz(timeZone)
  const [hours, minutes] = normalizePayCodeTime(workDayStart).split(':')
  const workDayOffset = Number(hours) * 60 + Number(minutes)

  return start.clone().subtract(workDayOffset, 'minutes').startOf('day')
}

export function isScheduledStartInWorkDay(scheduledStart, date, workDayStart, timeZone) {
  const { start, end } = getWorkDayWindow(date, workDayStart, timeZone)
  const value = moment.isMoment(scheduledStart) ? scheduledStart.clone() : moment(scheduledStart)

  return value.isSameOrAfter(start) && value.isBefore(end)
}

export function formatPayCodeDateForPayload(date, time, workDayStart, timeZone) {
  return getScheduledStartForWorkDay(date, time, workDayStart, timeZone).startOf('day').utc(true).toISOString()
}

export function formatScheduledStartForPayload(date, time, workDayStart, timeZone) {
  return getScheduledStartForWorkDay(date, time, workDayStart, timeZone).utc().format('YYYY-MM-DDTHH:mm[Z]')
}

export function formatHolidayDateForPayload(date, workDayStart, timeZone) {
  return getWorkDayWindow(date, workDayStart, timeZone).start.utc().toISOString()
}
